import { useIsIcebergEnabled } from "src/hooks/useIsIcebergEnabled";
import { PerformanceContent } from "src/performance/PerformanceContent";
import { PerformanceContentIceberg } from "src/performance/PerformanceContentIceberg";

/**
 * Router component that switches between Aurora and Iceberg performance implementations
 * based on the readDHv2 feature flag OR workspace history_mode setting
 */
export const PerformanceRouter: React.FC = () => {
  const useIceberg = useIsIcebergEnabled();

  return useIceberg ? <PerformanceContentIceberg /> : <PerformanceContent />;
};
